import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faShoppingCart, faList, faPlusCircle, faDollarSign,
    faIdCard, faBook, faSignOutAlt, faUsers, faTags, faNewspaper,
    faGlobeEurope, faCog, faFileInvoiceDollar, faHome, faMoneyCheckAlt
} from '@fortawesome/free-solid-svg-icons'

import {
    faSquare, faCheckSquare
} from '@fortawesome/free-regular-svg-icons'


Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(
    faShoppingCart, faList, faPlusCircle,faDollarSign,
    faIdCard, faBook, faSignOutAlt, faUsers, faTags, faNewspaper,
    faGlobeEurope, faCheckSquare, faSquare, faCog, faFileInvoiceDollar, faHome,
    faMoneyCheckAlt
);
